// import ScreenOrientationMgr from "../Fwk/ScreenOrientationMgr.js";
import Util from "@/Master/Util";
import {GameOrient} from "@/Master/FrameOrient/GameOrient";
import UtilBrowser from "@/Master/UtilBrowser";


type Orientation = 'portrait' | 'landscape';

/**
 * 屏幕方向类型枚举
 */
export const OrientType = {
    portraitPrimary: "portrait-primary",       // 竖屏-主方向（设备未旋转，通常是手机或平板的默认竖屏方向）。
    portraitSecondary: "portrait-secondary",   // 竖屏-次方向（设备倒置旋转180度，屏幕顶部朝下）。
    landscapePrimary: "landscape-primary",     // 横屏-主方向（设备顺时针旋转90度，通常是横屏的默认方向）。
    landscapeSecondary: "landscape-secondary", // 横屏-次方向（设备逆时针旋转90度，屏幕顶部朝左）。
    unknown: "unknown",                        // 未知方向
} as const;

type OrientTypeKey = keyof typeof OrientType;
type OrientTypeValue = typeof OrientType[OrientTypeKey];

/**
 * 帧方向管理器类，用于管理和更新屏幕方向。
 */
export default class FrameOrientMgr {
    static curFrame: HTMLElement | null = null;
    static tag: string = "[FrameOrientMgr]";
    static lastRotate90Tag: GameOrient = GameOrient.Vertical; // 默认根据自己的情况 1旋转90度  2不旋转
    static autoUpdateCount: number;
    static autoUpdateInter: any;

    static isInit: boolean = false;

    /**
     * 初始化帧方向管理器
     * @param frame - 要管理方向的帧元素
     */
    static init(frame: HTMLElement,direction:GameOrient): void {
        this.curFrame = frame;

        if (this.isInit)return;
        this.isInit = true;

        this.setGameDirection(direction);
        if (Util.isLog) {
            const isHorizontal = this.isGetHorizontal;
            console.log(this.tag, '初始化帧方向管理器 当前设备=', isHorizontal ? '横屏':'竖屏')
            console.log(this.tag, '初始化帧方向管理器 游戏默认方向=', direction == GameOrient.Horizontal ? '游戏横屏' : '游戏竖屏')
        }

        this.setIframeRotate90Forced(direction);
    }

    static setGameDirection(direction:GameOrient){
        const isHorizontal = this.isGetHorizontal;
        if (isHorizontal){
            //首次访问 横屏 默认设置横屏幕
            this.lastRotate90Tag = GameOrient.Horizontal;
        }else{
            //首次访问 竖屏 默认走配置
            this.lastRotate90Tag = direction;
        }
        if (Util.isLog) {
            console.log(this.tag, '设置游戏方向=', direction == GameOrient.Horizontal ? '游戏横屏' : '游戏竖屏')
        }
    }

    /**
     * 移除帧方向管理器的所有事件监听器
     */
    static Remove(): void {
        this.curFrame = null;
        this.isInit = false;
        if (Util.isLog) {
            console.log(this.tag, '移除帧方向管理器的所有事件监听器', this.curFrame)
        }
    }

    /**
     * 获取当前屏幕方向
     */
    static get getOrientation(): OrientTypeValue {
        if (screen.orientation && screen.orientation.type) {
            // 使用 Screen Orientation API 获取方向
            return screen.orientation.type as OrientTypeValue;
        } else if (window.orientation !== undefined) {
            // 使用 window.orientation 获取角度并转换为方向
            return this.getOrientationFromAngle(window.orientation);
        } else {
            // 不支持屏幕方向 API 的情况
            console.error(this.tag,"浏览器不支持 Screen Orientation API。");
            return OrientType.unknown;
        }
    }

    /**
     * 私有方法，用于将角度转换为方向类型
     * @param angle - 设备的旋转角度
     * @returns 屏幕方向类型
     */
    private static getOrientationFromAngle(angle: number): OrientTypeValue {
        switch (angle) {
            case 0:
                return OrientType.portraitPrimary;
            case 90:
            case -90:
                return OrientType.landscapePrimary;
            case 180:
                return OrientType.portraitSecondary;
            default:
                return OrientType.unknown;
        }
    }

    static get isGetHorizontal(){
        const orient = this.getOrientation;
        switch (orient) {
            case OrientType.landscapePrimary:
            case OrientType.landscapeSecondary://设备横屏
                return true;
            default://设备竖屏
                return false;
        }
    }

    //动态回调过来更新页面
    static onAutoUpdateOrientation() {
        if (Util.isIOS) {
            setTimeout(()=>{
                FrameOrientMgr.autoUpdateOrientation('IOSOutTime');
            })
        }else{
            FrameOrientMgr.autoUpdateOrientation('onAutoUpdateOrientation');
        }
    }

    static autoUpdateOrientation(tag?:string) {
        const isHorizontal = this.isGetHorizontal;
        if (Util.isLog) {
            console.log(this.tag, tag,'监听到方向变动 当前设备=', isHorizontal ? '横屏':'竖屏',' 宽高=', this.getWidth,this.getHeight)
        }

        this.autoUpdateCount = 0;
        if (this.autoUpdateInter){
            clearInterval(this.autoUpdateInter);
            this.autoUpdateInter = null;
        }
        this.autoUpdateInter = setInterval(() => {
            this.autoUpdateCount++;
            FrameOrientMgr.setIframeRotate90Forced(FrameOrientMgr.lastRotate90Tag);
            if (this.autoUpdateCount > 3) {
                if (this.autoUpdateInter){
                    clearInterval(this.autoUpdateInter);
                    this.autoUpdateInter = null;
                }
            }
        }, 100);

    }

    static gameSetIframeRotate90Forced(type:GameOrient){
        this.setIframeRotate90Forced(type);
        this.lastRotate90Tag = type;
    }

    // Web强制设置iframe为90度
    // type 1=横。2=竖
    static setIframeRotate90Forced(type:GameOrient){
        const isHorizontal = this.isGetHorizontal;
        if (Util.isLog) {
            console.group('Web强制设置iframe为90度',`设备方向=${isHorizontal ?'横':'竖'} `,`游戏强制方向=${type== GameOrient.Horizontal ?'横':'竖'}`)
        }
        if (isHorizontal){
            // 设备横屏
            //  游戏强制横屏幕-不旋转
            //  游戏强制竖屏幕-旋转90
            if (type == GameOrient.Horizontal) {
                this.SetForcedRotate90(false);
                if (Util.isLog) {
                    console.log(this.tag,'设备横屏  游戏强制横屏幕-不旋转')
                }
            } else {
                // 如果PC,强制游戏横屏幕-不旋转
                if (UtilBrowser.isDesktop){
                    this.SetForcedRotate90(false);
                    if (Util.isLog) {
                        console.log(this.tag,'设备横屏  游戏强制竖屏幕-如果PC,强制游戏横屏幕-不旋转')
                    }
                }else{
                    this.SetForcedRotate90(true);
                    if (Util.isLog) {
                        console.log(this.tag,'设备横屏  游戏强制竖屏幕-旋转90')
                    }
                }
            }
        }else{
            // 设备竖屏
            //  游戏强制横屏幕-旋转90
            //  游戏强制竖屏幕-不旋转
            if (type == GameOrient.Horizontal){
                this.SetForcedRotate90(true);
                if (Util.isLog) {
                    console.log(this.tag,'设备竖屏  戏强制横屏幕-旋转90')
                }
            }else{
                this.SetForcedRotate90(false);
                if (Util.isLog) {
                    console.log(this.tag,'设备竖屏  游戏强制竖屏幕-不旋转')
                }
            }
        }
        if (Util.isLog){
            console.groupEnd();
        }
    }

    /**
     * 设置强制旋转90度
     */
    static SetForcedRotate90(open: boolean): void {
        if (this.curFrame == null) {
            // console.error(`${this.tag} => 当前帧不存在`);
            return;
        }
        let isLandscape = open;
        const frameDom = this.curFrame;
        if (isLandscape) {
            // this.lastRotate90Tag = GameOrient.Horizontal;
            frameDom.style.height = `${window.innerWidth}px`;
            frameDom.style.width = `${window.innerHeight}px`;
            frameDom.style.maxHeight = `100vw`;
            frameDom.style.maxWidth = `100vh`;
            // 通过CSS样式旋转90度
            frameDom.classList.add("forced-landscape-screen");
        } else {
            // this.lastRotate90Tag = GameOrient.Vertical;
            // 横屏时则正常
            frameDom.style.height = `${window.innerHeight}px`;
            frameDom.style.width = `${window.innerWidth}px`;
            frameDom.style.maxHeight = `100vh`;
            frameDom.style.maxWidth = `100vw`;

            // 通过移除类去掉CSS样式
            frameDom.classList.remove("forced-landscape-screen");
        }
    }

    static get getWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    static get getHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }


}

